export default {
    SET_USER(state, user) {
        state.user = user;
    },
    SET_TOKEN(state, token) {
        state.token = token;
    },
    CLEAR_AUTH_DATA(state) {
        state.user = null;
        state.token = null;
    },
    REQUEST_OK(state, message) {
        state.statusMessage = message;
    }
}